import React, { useCallback, useMemo } from 'react';
import { useIonRouter } from '@ionic/react';
import './AccessDeniedModal.scss';
import { Browser } from '@capacitor/browser';
import { useIntl } from 'react-intl';
import { HomeMessages } from '../intl/HomeMessages';
import { GenericMessages } from '../intl/GenericMessages';
import { AppModal } from 'src/components/reusable-components/app-modal/AppModal';

export interface AccessDeniedModalProps {
  isOpen: boolean;
}

const onContact = async () => {
  await Browser.open({
    url: 'https://www.stoneagetools.com/support',
    presentationStyle: 'popover',
    windowName: '_blank',
  });
};

export const AccessDeniedModal: React.FC<AccessDeniedModalProps> = ({ isOpen }) => {
  const router = useIonRouter();
  const { formatMessage } = useIntl();

  const onClose = useCallback(() => {
    router.push('/landing', 'root', 'replace');
  }, [router]);

  const contactButton = useMemo(() => {
    return {
      label: formatMessage(HomeMessages.accessDeniedContactStoneAge),
      onClick: onContact,
    };
  }, [formatMessage]);

  const cancelButton = React.useMemo(() => {
    return {
      label: formatMessage(GenericMessages.cancelButtonLabel),
      onClick: onClose,
    };
  }, [formatMessage, onClose]);

  return (
    <AppModal
      className="AccessDeniedModal"
      isOpen={isOpen}
      title={formatMessage(HomeMessages.accessDeniedTitle)}
      onClose={onClose}
      primaryButton={contactButton}
      secondaryButton={cancelButton}
    >
      {formatMessage(HomeMessages.accessDeniedMessage)}
    </AppModal>
  );
};
